module.exports = __webpack_public_path__ + "static/media/fontes.ece5f084.jpg";